// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__aq3HF","overflowing":"ReadFullNote_overflowing__28t3E"};